import * as React from "react";
const SvgMoreHorizontal = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" {...props}>
    <path
      fill="#8A8A8A"
      stroke="#8A8A8A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 9.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M14.25 9.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M3.75 9.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
    />
  </svg>
);
export default SvgMoreHorizontal;
